import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { IconEye } from '@calendly/ui/components/glyphs/IconEye';
import { BodyText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { useViewportSize } from '@calendly/ui/hooks/viewport-size-context';
import { colorTextSecondary } from '@calendly/ui/theme';
import { getKindDescription } from 'services/event_types';
import { EditorPrimaryActions } from './editor_primary_actions';
import { HeaderMoreMenu } from './header_more_menu';
const rootCss = "r19r3qho";
const titleBlockCss = "t13t59gb";
const titleCss = "t13bfac";
const metaRowCss = "mkizyzo";

// TODO(cui-drift): CUI Badge hardcodes LabelText size="large" (no size prop).
// Figma Badge (label/small): 11px / 14px LH, padding 2×6. CUI LabelText small
// uses 16px LH, so match Figma tokens directly until Badge supports size="small".
const statusBadgeCss = "s1r7n8im";
const statusBadgeLabelCss = "s1px64w8";
const statusBadgeLiveCss = "s91i3q9";
const statusBadgeDraftCss = "s9k4xxa";
const rightClusterCss = "r1tvxch6";
export const EditorHeader = ({
  eventType,
  showPreviewButton = false,
  onOpenPreview,
  showPrimaryActions = true
}) => {
  const {
    isSmallViewport: isPhone
  } = useViewportSize();
  const isLive = eventType.active;
  const kindDescription = getKindDescription({
    isAdhocEventType: eventType.isAdhocEventType,
    isCollective: eventType.isCollective,
    isRoundRobin: eventType.isRoundRobin,
    isCollectiveRoundRobin: eventType.isCollectiveRoundRobin,
    isGroup: eventType.isGroup,
    isSolo: eventType.isSolo
  });
  return <div className={rootCss} data-testid="editor-header">
      <div className={titleBlockCss}>
        <span className={titleCss} data-testid="editor-header-title">{eventType.name}</span>
        <span className={metaRowCss}>
          {kindDescription && <BodyText color={colorTextSecondary} size="medium" inline data-testid="editor-header-kind">
              {kindDescription}
            </BodyText>}
          <span className={`${statusBadgeCss} ${isLive ? statusBadgeLiveCss : statusBadgeDraftCss}`} data-testid="editor-header-status-badge">
            <span className={statusBadgeLabelCss}>
              {isLive ? I18n.t('publisher.event_type_editor_crud.header.badge.live') : I18n.t('publisher.event_type_editor_crud.header.badge.draft')}
            </span>
          </span>
        </span>
      </div>
      <div className={rightClusterCss}>
        {showPreviewButton && <Button appearance="secondary-outline" size="medium" data-testid="editor-header-preview" onClick={onOpenPreview}>
            <UiIcon icon={IconEye} size="small" title="" />
            {I18n.t('publisher.event_type_editor_crud.header.preview')}
          </Button>}
        {showPrimaryActions ? <EditorPrimaryActions eventType={eventType} /> : <HeaderMoreMenu eventType={eventType} isPhone={isPhone} />}
      </div>
    </div>;
};

require("./editor_header.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./editor_header.js");